import React from 'react'
import leafImg from '../../assets/landing/footer-leaf.png'
import logo from '../../assets/landing/footer-logo.png'
import frogImg from '../../assets/landing/footer-frog.png'
import boardImg from '../../assets/landing/board.png'
import boardShadowImg from '../../assets/landing/board-shadow.png'
import socialImg1 from '../../assets/landing/social-1.png'
import socialImg2 from '../../assets/landing/social-2.png'
import socialImg3 from '../../assets/landing/social-3.png'
import frogShadowImg from '../../assets/landing/frog-shadow.png'

const Footer = () => {
  return (
    <footer className="bg-[#A8D63F]">
      <div className=" -mt-16 max-w-7xl mx-auto">
        <div className="pt-20 ml-4 lg:ml-16 mr-4 lg:mr-0 flex flex-col lg:flex-row items-center justify-between lg:gap-10 gap-2 relative">
          <div className="relative z-40">
            <img
              src={logo}
              alt="logo img"
              className="h-[44px] lg:h-auto w-auto mx-auto"
            />
            <div className="text-[14px] lg:text-[35px] font-black flex flex-row flex-wrap justify-center lg:justify-start lg:flex-col gap-4 mt-2 lg:mt-10 font-sourGummy">
              <a 
              href = "https://littlepepe.com/little-pepe-whitepaper.pdf" 
              target="_blank" 
              rel ="noopener,noreferrer">
              WHITEPAPER
              </a> 
              <a
              href = "https://littlepepe.com/how-to-buy/" 
              target="_blank" 
              rel ="noopener,noreferrer">
              HOW TO BUY
              </a>
              <a
              href = "https://littlepepe.com/777k-giveaway/" 
              target="_blank" 
              rel ="noopener,noreferrer">
              WIN $777K
              </a>
              <a
              href = "https://littlepepe.com/terms/" 
              target="_blank" 
              rel ="noopener,noreferrer">
              TERMS & CONDITION'S
              </a>
              <a
              href = "https://littlepepe.com/privacy/" 
              target="_blank" 
              rel ="noopener,noreferrer">
              PRIVACY POLICY
              </a> 
              <a
              href = "https://littlepepe.com/cookies/" 
              target="_blank" 
              rel ="noopener,noreferrer">
              COOKIES
              </a>
              <p className="text-[19px] text-center font-normal my-4 hidden lg:block">
                © 2025 LILPEPE all rights reserved.
              </p>
            </div>
          </div>
          <div className="relative lg:absolute z-0 lg:top-10 lg:left-10">
            <img src={frogImg} alt="frog img" />
          </div>
          <div className="lg:absolute z-0 bottom-10 left-[30%] hidden md:flex">
            <img src={frogShadowImg} alt="frog shadow img" />
          </div>
          <div className="relative z-40 flex flex-col items-center lg:items-end justify-center gap-4 lg:gap-10">
            <div className="relative">
              <img
                src={boardImg}
                alt="sign board img"
                className="relative z-40"
              />
              <img
                src={boardShadowImg}
                alt="sign board shadow img"
                className="absolute -bottom-5 right-7 z-10"
              />
              <div className="flex items-center text-[36px] font-bold gap-4 uppercase absolute top-4 md:top-4 left-8 z-50 font-sourGummy">
                <img src={socialImg1} alt="telegram img" />
                <a
                href = "https://t.me/littlepepetoken" 
                target="_blank" 
                rel ="noopener,noreferrer">
                Telegram
                </a>
              </div>
              <div className="flex items-center text-[36px] font-bold gap-4 uppercase absolute top-[105px] md:top-[108px] sm:top-[108px] left-8 z-50 font-sourGummy">
                <img src={socialImg2} alt="twitter img" />
                  <a
                href = "https://x.com/littlepepetoken" 
                target="_blank" 
                rel ="noopener,noreferrer">
                Twitter
                </a>
              </div>
              <div className="flex items-center text-[36px] font-bold gap-4 uppercase absolute top-[176px] sm:top-[186px] left-8 z-50 font-sourGummy">
                <img src={socialImg3} alt="linktree img" />
                 <a
                href = "https://x.com/littlepepetoken" 
                target="_blank" 
                rel ="noopener,noreferrer">
                Linktree
                </a>
              </div>
            </div>
            <p className="max-w-[506px] text-center text-[11px] lg:text-xl mt-4 lg:mt-0">
              Disclaimer: Cryptocurrency may be unregulated in your
              jurisdiction. The value of cryptocurrencies may fluctuate Profits
              may be subject to capital gains or other taxes applicable in your
              jurisdiction
            </p>
            <p className="block lg:hidden text-center text-[11px] mb-4">
              © 2025 LILPEPE all rights reserved.
            </p>
          </div>
        </div>
        <img src={leafImg} alt="leafs img" className="relative" />
      </div>
    </footer>
  )
}

export default Footer
